import { Component, inject } from '@angular/core';
import { DipendentiService } from 'src/app/shared/services/dipendenti.service';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import * as FileSaver from 'file-saver';
import { ImportDipendentiResult } from 'src/app/models/import-dipendenti-result';
import notify from 'devextreme/ui/notify';
import {
  DxButtonComponent,
  DxFileUploaderComponent,
  DxListComponent,
  DxLoadPanelComponent,
  DxValidatorComponent,
} from 'devextreme-angular';
import { DxiValidationRuleComponent } from 'devextreme-angular/ui/nested';

@Component({
  selector: 'app-dipendenti-import',
  templateUrl: './dipendenti-import.component.html',
  styleUrls: ['./dipendenti-import.component.scss'],
  imports: [
    DxButtonComponent,
    DxFileUploaderComponent,
    DxLoadPanelComponent,
    DxListComponent,
    DxValidatorComponent,
    DxiValidationRuleComponent,
  ],
})
export class DipendentiImportComponent {
  private dipendentiS = inject(DipendentiService);
  private nS = inject(NavigatorService);
  visibleLoadPanel = false;
  fileValue: any[] = [];
  importResult: ImportDipendentiResult | null = null;

  goToDetail(e) {
    this.nS.goToDipendentiDetail(e.id);
  }

  allegaFile(e: any, files: any) {
    this.importResult = null;
    this.visibleLoadPanel = true;
    const formData = new FormData();
    formData.append('file', files[0]);
    this.dipendentiS.importDatiDipendentiXls(formData).subscribe({
      next: (res) => {
        this.visibleLoadPanel = false;
        this.importResult = res;
        notify('Importazione completata, verifica risultati', 'success');
        this.clearForm();
      },
      error: (error) => {
        this.visibleLoadPanel = false;
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore importazione dati dipendenti', 'warning');
        }
      },
    });
  }
  onScaricaFileEsempioClick() {
    this.visibleLoadPanel = true;
    this.dipendentiS.downloadFileEsempio().subscribe({
      next: (res) => {
        this.visibleLoadPanel = false;
        FileSaver.saveAs(res, 'FileEsempioImportDipendenti.xlsx');
      },
      error: (error) => {
        this.visibleLoadPanel = false;
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore download file esempio', 'warning');
        }
      },
    });
  }

  clearForm() {
    this.fileValue = [];
  }

  onEsciClick() {
    this.nS.goToDipendenti();
  }
}
